export const abastecimentosRoute: string = 'abastecimentos';
export const abastecimentosModuleName: any = {plural: 'Abastecimentos', single: 'Abastecimento'};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/shared/data.service.ts
 **/